module.exports = __webpack_public_path__ + "img/Header1.4df067e8.jpg";